import { useEffect, useState } from "react";
import { Grid2 as Grid, Container, Modal, Typography, Button, Box } from "@mui/material";
import { Navigate, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import FormHome from "../../components/home/FormHome";
import { addFiscales } from "../../actions/users";
import { getEstados, getEstadosEEUU } from "../../actions/estados";
import { isEmpty } from "../../components/common/helpers";

import { connect } from "react-redux";

const Home = ({ user, error, isAuthenticated, addFiscales }) => {
  //Redirect
  if(!isAuthenticated){
    return <Navigate to="/" />
  }

  if(!isEmpty(user?.datos_empresas)){
    return <Navigate to="/detalle-inversiones" />
  }

  if(user?.tipo_usuario){
    return <Navigate to="/admin/inversiones" />
  }

  const [ newRegister, setNewRegister ] = useState({
    nombre: "",
    email: "",
    ext: "52",
    tel: "",
    razon: "",
    rfc: "",
    regimen: "",
    pais: "",
    estado: "",
    cp: "",
    delegacion: "",
    colonia: "",
    calle: "",
    numExt: "",
    numInt: "",
    terms: false,
    privacy: false,
  });
  const [errors, setErrors] = useState({});
  const [open, setOpen] = useState(false);
  const [estados, setEstados] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const navigate = useNavigate();
  const id = user?._id;
  
  useEffect(() => {
    ( async () => {
      try {
        if(newRegister.pais === "Mexico"){
          const arrEstados = await getEstados();
          setEstados(arrEstados);
        } else {
          const arrEstados = await getEstadosEEUU();
          setEstados(arrEstados);
        }
      }
      catch (err) {
        console.error("Error: ", err);
      }
    })();
  }, [newRegister.pais])

  useEffect(() => {
    if(newRegister.pais === "Mexico"){
      const index = estados?.findIndex(edo => edo.estado === newRegister.estado);
      setMunicipios(estados[index].municipio); 
    }
  }, [newRegister.estado]);

  useEffect(() => {
    const errores = {};
    if(Array.isArray(error)){
      window.scrollTo({ top: 0, behavior: 'smooth' });
      error.forEach(info => {
        if(info.path === 'nombre'){
          errores.nombre = info.msg
        }
        if(info.path === 'email'){
          errores.email = info.msg
        }
        if(info.path === 'tel'){
          errores.tel = info.msg
        }
        if(info.path === 'razon'){
          errores.razon = info.msg
        }
        if(info.path === 'rfc'){
          errores.rfc = info.msg
        }
        if(info.path === 'regimen'){
          errores.regimen = info.msg
        }
        if(info.path === 'pais'){
          errores.pais = info.msg
        }
        if(info.path === 'estado'){
          errores.estado = info.msg
        }
        if(info.path === 'cp'){
          errores.cp = info.msg
        }
        if(info.path === 'delegacion'){
          errores.delegacion = info.msg
        }
        if(info.path === 'colonia'){
          errores.colonia = info.msg
        }
        if(info.path === 'calle'){
          errores.calle = info.msg
        }
        if(info.path === 'numExt'){
          errores.numExt = info.msg
        }
        return errores
      });
      setErrors(errores)
    } else {
      setErrors(error)
    }
  }, [error]);

  const handleClose = () => {
    setOpen(false);
    return navigate("/detalle-inversiones");
  };

  const handleChange = e => {
    const key = e.target.name;
    const newValue = e.target.value;
    setNewRegister({
      ...newRegister,
      [key]: newValue
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(!newRegister.terms || !newRegister.privacy){
      return setErrors({
        errors,
        terms: "Aceptar terminos",
        privacy: "Aceptar politica de privacitad"
      });
    }

    await addFiscales(newRegister, id);
    setOpen(true);
  }

  return (
    <Container component="main" maxWidth="lg">
      <Grid container mt={{ xs: 10, md: 11 }}>
        <Grid container direction="column" alignItems="center" justifyContent="center" mt={5}>
          <Typography variant="h3" component="h2">
            Datos de la empresa inversora
          </Typography>
          <Typography>
            Completa el formulario con la información de la empresa que invertirá en tu proyecto.
          </Typography>
        </Grid>
        <Grid className="form" size={{ md: 7 }}>
          <FormHome
            errors={errors}
            newRegister={newRegister}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            estados={estados}
            municipios={municipios}
          />
        </Grid>
        <Modal
          open={open}
          className="modal-content"
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="modal-message modal-large" >
            <img width="150" src="/Sticker.png" alt="Estatus" />
            <Typography className="titleMain" variant="h3" component="h3" mt={3}>
              Ya puede invertir
            </Typography>
            <Typography mt={3} mb={5}>
              Hemos recibido correctamente sus datos. Ahora verificaremos los detalles de tu inversión. Te notificaremos cuando el proceso haya sido completado.
              ¡Gracias por confiar en nosotros y ser parte de esta oportunidad!
            </Typography>
            <Button
              onClick={handleClose}
              type="button"
              variant="contained"
            >
              OK
            </Button>
          </Box>
        </Modal>
      </Grid>
    </Container>
  );
}

Home.propTypes = {
  addFiscales: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  user: state.auth.user,
  error: state.users.error,
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps, { addFiscales })(Home);
